









import { defineComponent } from "@vue/composition-api"

import { createNamespacedHelpers } from "vuex-composition-helpers"
import { AppleGiftCardActions } from "../../store/apple-gift-card/actions"
import { AppleGiftCardGetters } from "../../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../../store/apple-gift-card/mutations"
import { AppleGiftCardState } from "../../store/apple-gift-card/state"

const { useGetters } = createNamespacedHelpers<AppleGiftCardState, AppleGiftCardGetters, AppleGiftCardActions, AppleGiftCardMutations>(
  "appleGiftCard"
)

export default defineComponent({
  name: "BannerText",
  setup() {
    const { bannerText } = useGetters(["bannerText"])

    const locationChange = (e: Event) => {
      e.preventDefault()
      if (bannerText?.value?.url) {
        location.href = bannerText.value.url
      }
    }

    return { bannerText, locationChange }
  }
})
